import type { TenantResources } from '../en/tenant';

export const tenant: TenantResources = {
  picker: {
    via: 'über {{name}}',
    badge: {
      inactive: 'Inaktiv',
      pending: 'Aktivierung ausstehend',
      invited: 'Eingeladen',
      deactivated: 'Deaktiviert',
    },
  },
  groups: {
    multipleTenants: 'Mehrere Mandanten',
  },
};
